<template>
    <Button :label="$t('edit_shipment')" icon="pi pi-pencil" class="p-button-success p-button-sm mr-2" @click="onShowEditModal" />

    <CustomSidebar v-model:visible="showModal" position="bottom" :dismissable="false" :title="$t('edit_shipment')" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button p-button-success mr-1" :label="$t('edit_shipment')" @click="onEditShipment"></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalDataShipment :data="shipmentData" v-if="shipmentData" :showDetailed="true" :showDrivers="false"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :loading="!shipmentData" :value="shipmentData ? shipmentData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Order_No" :header="$t('order_no')" key="Order_No" style="width:10%">  
                        </Column>
                        <Column field="SAP_No" :header="$t('sap_no')" key="SAP_No" style="width:10%">  
                        </Column>
                        <Column field="Item_No" header="Item No" key="Item_No" style="width:10%">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="Material_Name">
                        </Column>
                        <Column field="Qty" header="Qty" key="Remarks" style="width:15%">
                            <template #body="slotProps">
                                <div class="p-fluid">
                                    <!-- <InputText v-model="slotProps.data[slotProps.column.props.field]" /> -->
                                    <InputNumber v-model="slotProps.data[slotProps.column.props.field]" mode="decimal" :optionalDecimal="true" :max="slotProps.data.order_os_qty" :disabled="disableQtyInput(slotProps)" />
                                </div>
                            </template>
                        </Column>
                        <Column field="order_os_qty" :header="$t('os_qty')" key="Active" style="width:15%">
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />
                    
                    <div class="p-inputtext-sm">
                        <AssignEditDriver 
                            v-if="shipmentData" 
                            :materials="shipmentData ? shipmentData.Details : []" 
                            :transporterCode="transporter" 
                            :locationCode="location" 
                            :isIndividual="isIndividual" 
                            :isCollective="isCollective" 
                            :isRelation="isRelation" 
                            :isAssign="true"
                            :assignMultiple="false"
                            :dataModel="assignEditDriverModel"
                            :drivers="shipmentData.Drivers"
                            :isRegisteredIn="isRegisteredIn"
                            :warehouseCode="warehouseCode"
                            />
                    </div>
                </ScrollPanel>
            </div>
        </div>

        
    </CustomSidebar>     

</template>
<script>
    import ModalDataShipment from '../Helper/_ModalDataShipment.vue'
    import ShowShipment from '../Helper/_ShowShipment.vue'
    import AssignEditDriver from '../Helper/_AssignEditDriver.vue'

    export default{
        components: {
            'ModalDataShipment': ModalDataShipment,
            'ShowShipment': ShowShipment,
            'AssignEditDriver': AssignEditDriver
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
        },
        data(){
            return {
                showModal: false,
                shipmentData: null,
                isIndividual: false,
                isCollective: false,
                isRelation: false,
                driverModels: [],
                driverModel: null,
                transporter:"",
                location: "",
                dataUrl: "shipment/",
                blocked: false,
                isRegisteredIn: false,
                orderType: null,
                useLN: false,
                warehouseCode: "",
            }
        },
        mounted(){

        },
        methods:{
            reset(){
                this.transporter = "";
                this.location = "";
                this.driverModels = [];
                this.driverModel = null;
                this.isIndividual = false;
                this.isCollective = false;
                this.isRelation = false;
                this.shipmentData = null;
                this.isRegisteredIn = false;
                this.orderType = null;
                this.useLN =  false;

                this.warehouseCode = "";
            },
            onShowEditModal(){
                this.showModal = true;
                this.shipmentData = null;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data.Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.shipmentData = response.data.data.header;
                            self.useLN = response.data.data.header.use_ln;

                            self.driverModel = response.data.data.assign_driver;
                            self.driverModels = self.shipmentData.Drivers;

                            self.transporter = self.shipmentData.Transporter_Code;
                            self.location = self.shipmentData.warehouse_location_code;

                            self.isRelation = self.shipmentData.is_relation;
                            self.isCollective = self.shipmentData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.COLLECTIVE;
                            self.isIndividual = self.shipmentData.shipment_type_category == self.$SHIPMENT_TYPE_CATEGORY.INDIVIDUAL;

                            if(response.data.data.details != null && response.data.data.details.length > 0){
                                self.orderType = response.data.data.details[0].order_type;
                            }

                            self.isRegisteredIn = self.shipmentData.is_registered_in;

                            self.warehouseCode = self.shipmentData.Warehouse_Code;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

            }, 
            disableQtyInput(event){
                return this.isCollective || this.useLN; //|| (event.data.collective_ln == "N" && event.data.order_type.Use_LN); 
            },
            onEditShipment(){
                var self = this;

                self.blocked = true;

                var data = {
                    shipment_id: this.data.Id,
                    drivers: this.driverModels,
                    materials: this.shipmentData.Details
                };

                this.$axios.put(this.$API_URL + this.dataUrl + "edit_shipment", data)
                    .then((response) => {
                        if (response.data.success) {
                            self.showModal = false;
                            self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                            self.$emit('close');
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

            }
        },
        computed:{
            assignEditDriverModel(){
                return {driverModel: this.driverModel, driverModels: this.driverModels};
            }
        }
    }
</script>